var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-divider'),_c('h5',{staticClass:"mt-4 mb-2"},[_vm._v("Questions")]),_c('MeetingStepQuestions',{attrs:{"questions":_vm.step.questions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }